import Swiper from 'swiper';
import {Navigation, Autoplay } from "swiper/modules";
Swiper.use([Navigation, Autoplay]);

const imageSlider = new Swiper('.image-slider',{
  direction: 'horizontal',
  slidesPerView: 1,
  spaceBetween: 30,
  autoHeight: false,
  loop: true,
  effect: 'fade',
  speed: 1000,
  fadeEffect: {
    crossFade: true
  },
  navigation:{
    nextEl: ".image-swiper-button-next",
    prevEl: ".image-swiper-button-prev",
  },
  breakpoints:{
    1100:{
      slidesPerView: 3,
    },
    675:{
      slidesPerView: 2,
    }
  }
})
